
export default function PhilosophySection() {
  const philosophyPoints = [
    {
      icon: 'ri-search-eye-line',
      title: 'Thorough Analysis',
      description: 'Every financial situation is unique. I take the time to understand your complete picture before recommending solutions.'
    },
    {
      icon: 'ri-team-line',
      title: 'Partnership Approach',
      description: 'You\'re not just a client – you\'re a partner in this journey. I work alongside you every step of the way.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Creative Solutions',
      description: 'When conventional financing isn\'t an option, I leverage my private lending network to find alternative paths.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Trust & Transparency',
      description: 'Clear communication, honest advice, and transparent processes. You\'ll always know where you stand.'
    }
  ];
  
  return (
    <section className="py-20 bg-red-700 text-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            My Philosophy: <span className="text-black">Your Success First</span>
          </h2>
          <p className="text-xl text-red-100 max-w-4xl mx-auto leading-relaxed">
            In 25+ years of mortgage lending, I've learned that success isn't just about getting approved – 
            it's about finding the right solution that fits your life, your goals, and your future.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {philosophyPoints.map((point, index) => (
            <div key={index} className="text-center group">
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-dark-800 transition-colors duration-300">
                <i className={`${point.icon} text-3xl text-red-700 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-xl font-bold mb-4">{point.title}</h3>
              <p className="text-red-100 leading-relaxed">{point.description}</p>
            </div>
          ))}
        </div>
        
        <div className="bg-dark-900 border border-dark-700 rounded-2xl p-4 sm:p-6 lg:p-12">
          <div className="text-center">
            <h3 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">
              Specializing in <span className="text-red-500">Complex Cases</span>
            </h3>
            <p className="text-gray-300 text-base sm:text-lg leading-relaxed mb-6 max-w-4xl mx-auto">
              My experience with private lending makes me uniquely qualified to help clients who face 
              challenges with traditional mortgage approval. Self-employed, new to Canada, credit challenges, 
              or unique property types – I've seen it all and found solutions.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 lg:gap-8">
              <div className="text-center">
                <div className="text-xl sm:text-2xl font-bold text-red-500">Private</div>
                <div className="text-xs sm:text-sm text-gray-400">Lending Access</div>
              </div>
              <div className="text-center">
                <div className="text-xl sm:text-2xl font-bold text-red-500">Complex</div>
                <div className="text-xs sm:text-sm text-gray-400">Case Specialist</div>
              </div>
              <div className="text-center">
                <div className="text-xl sm:text-2xl font-bold text-red-500">Creative</div>
                <div className="text-xs sm:text-sm text-gray-400">Solutions</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
